const isLoggerEnabler = false

export const timber_debug = (message: any) => {
  if (isLoggerEnabler) console.log(message)
}

export const timber_info = (message: any) => {
  if (isLoggerEnabler) console.info(message)
}

export const timber_warn = (message: any) => {
  if (isLoggerEnabler) console.warn(message)
}

export const timber_error = (message: any) => {
  if (isLoggerEnabler) console.error(message)
}
